export const aviationImg = (level: number) => {
    const url = require(`@/assets/aviations/a${level}.png`);
    return url;
};
